import React, { useEffect, useState } from "react";
import Table from "../../components/Table";
import axios from "axios";
import AddLeads from "./AddLeads";
import { toast } from "react-toastify";
import { Button, Modal } from "antd";
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";
import ViewLeads from "./ViewLeads";
import EmailModalForLeads from "../../components/EmailModalForLeads";

const AllLeads = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectionStatus, setSelectionStatus] = useState("Pending");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [loading, setLoading] = useState(false);
  const [confirmCount, setConfirmCount] = useState(0);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [leadData, setLeadData] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [showCheckboxes, setShowCheckboxes] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query]
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;


  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [emailLoading, setEmailLoading] = useState(false);



  const handleSendMail = (lead) => {
    setSelectedLead(lead);          // Store clicked lead info
    setEmailModalOpen(true);        // Open modal
  };

  const fetchLeads = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/api/leads/get-leads`, {
        withCredentials: true,
      });

      setLeadData(response.data.data);
      setSelectedLeads([])
      setSelectAll(false)
      setShowCheckboxes(false)
    } catch (error) {
      console.error("Error fetching leads:", error);
    }
    finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLeads();
  }, [apiUrl]);

  const handleRowClick = async (leadId) => {
    //  Prevent modal from opening if checkboxes are active
    if (showCheckboxes) return;

    setOpenDropdown(null);

    try {
      const response = await axios.get(`${apiUrl}/api/leads/get-leads-data/${leadId}`, {
        withCredentials: true,
      });

      // console.log("Lead data:", response.data.data);
      setSelectedLeads(response.data.data);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching lead data:", error);
    }
  };


  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedLeads(null);
  };

  const openEditModal = () => {
    setIsModalOpen(false);
    setIsAddModalOpen(true);
  };

  const handleReload = () => {
    fetchLeads();
  };
  const handleLeadEntriesChange = (value) => {
    setEntriesPerPage(value);
    setCurrentPage(1);
  };
  const [leadEmailModalOpen, setLeadEmailModalOpen] = useState(false);

  // Status Change Handler
  const handleStatusChange = async (leadId, newStatus) => {
    try {
      await axios.put(
        `${apiUrl}/api/leads/update-status`,
        { leadId, status: newStatus },
        { withCredentials: true }
      );

      // Update local state after API call
      setLeadData((prevLeads) =>
        prevLeads.map((lead) =>
          lead._id === leadId ? { ...lead, status: newStatus } : lead
        )
      );

      toast.success(`Status updated to ${newStatus}`);
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status.");
    }
  };

  // **Handle Lead Selection**

  const handleEmailSubmit = async (subject, message) => {
    try {
      setEmailLoading(true);
      const response = await axios.post(`${apiUrl}/api/sendmail`, {
        to: selectedLead?.email,
        subject,
        text: message,
      }, {
        withCredentials: true,
      });

      toast.success(response.data.message || "Email sent successfully!");
      setEmailModalOpen(false);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to send email.");
    } finally {
      setEmailLoading(false);
    }
  };





  // **Deleting Selected Leads (excluding confirmed leads)**
  const handleDeleteSelected = async () => {
    if (selectedLeads?.length === 0) {
      setShowCheckboxes(true); //  Ensure checkboxes remain visible
      return;
    }

    const leadsToDelete = selectedLeads?.filter(
      (leadId) => leadData.find((lead) => lead._id === leadId)?.status !== "Confirmed"
    );

    if (leadsToDelete?.length === 0) {
      toast.warning("Confirmed leads cannot be deleted.", { autoClose: 1500 });
      return; //  Don't hide checkboxes
    }

    const confirmDelete = window.confirm(`Are you sure you want to delete ${leadsToDelete?.length} selected leads?`);
    if (!confirmDelete) return;

    try {
      await axios.delete(`${apiUrl}/api/leads/delete-lead-data`, {
        data: { leadIds: leadsToDelete },
        withCredentials: true,
      });

      setLeadData((prevLeads) => prevLeads.filter((lead) => !leadsToDelete.includes(lead._id)));
      setSelectedLeads([]);
      setShowCheckboxes(false); //  Only hide checkboxes after successful deletion
      setSelectAll(false);
      toast.success(" Selected leads deleted successfully.", { autoClose: 2000 });
    } catch (error) {
      console.error("Error deleting leads:", error);
      toast.error(" Error deleting leads. Please try again.", { autoClose: 2000 });
    }
  };

  const handleSelectAllChange = () => {
    if (selectedLeads?.length === leadData?.length) {
      setSelectedLeads([]);
    } else {
      setSelectedLeads(leadData.map((lead) => lead._id));
    }
    // setShowCheckboxes(true); //  Ensure checkboxes remain visible
  };





  const handleCheckboxChange = (leadId) => {
    setSelectedLeads((prevSelected) => {
      let updatedSelection = Array.isArray(prevSelected) ? [...prevSelected] : [];

      if (updatedSelection.includes(leadId)) {
        updatedSelection = updatedSelection.filter((id) => id !== leadId);
      } else {
        updatedSelection.push(leadId);
      }

      // console.log("Updated Selected Leads:", updatedSelection);
      return updatedSelection;
    });

  //  Keep checkboxes visible even if a confirmed lead is selected
  setShowCheckboxes(true);
};





  const columns = [
    ...(showCheckboxes
      ? [
        {
          header: (
            <input
              type="checkbox"
              checked={selectedLeads?.length > 0 && selectedLeads?.length === leadData?.length}
              onChange={handleSelectAllChange}
            />
          ),
          accessor: "checkbox",
          render: (row) => (
            <input
              type="checkbox"
              checked={Array.isArray(selectedLeads) && selectedLeads?.includes(row._id)}
              disabled={row.status === "Confirmed"} // ✅ Disable checkbox if status is "Confirmed"
              onChange={(e) => {
                e.stopPropagation();
                handleCheckboxChange(row._id);
              }}
            />
          ),
        },
      ]
      : []),

    { header: "Name", accessor: "name", className: "cursor-pointer min-w-[120px]" },
    { header: "Email", accessor: "email", className: "min-w-[180px] hidden md:table-cell" },
    { header: "Phone", accessor: "phoneNo", className: "min-w-[120px]" },
    { header: "Work", accessor: "work", className: "min-w-[120px] hidden lg:table-cell" },
    { header: "Country", accessor: "country", className: "min-w-[100px] hidden md:table-cell" },
    {
      header: "Status",
      accessor: "status",
      className: "min-w-[120px] text-center",
      render: (row) => {
        const allStatuses = ["Pending", "Reached Out", "Confirmed"];
        const remainingStatuses = allStatuses.filter((s) => s !== row.status);

        return (
          <div className="relative">
            {row.status === "Confirmed" ? (
              <span className="py-1 px-2 rounded-md text-white bg-green-500">{row.status}</span>
            ) : (
              <>
                <button
                  className={`py-1 px-2 rounded-md text-white ${row.status === "Pending" ? "bg-yellow-500" : "bg-blue-500"
                    }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenDropdown(openDropdown === row._id ? null : row._id);
                  }}
                >
                  {row.status}
                </button>
                {openDropdown === row._id && (
                  <div
                    className="absolute left-0 right-0 bg-white shadow-lg border rounded mt-1 z-50 max-h-40 overflow-y-auto"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {remainingStatuses.map((status) => (
                      <button
                        key={status}
                        className="block px-4 py-2 w-full text-left hover:bg-gray-100 text-gray-700"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleStatusChange(row._id, status);
                          setOpenDropdown(null);
                        }}
                      >
                        {status}
                      </button>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        );
      },
    },

    {
      header: "WhatsApp",
      accessor: "whatsapp",
      render: (row) => (
        <a
          href={`https://wa.me/${row.phoneNo}`} // ✅ Use 'row' instead of 'lead'
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp className="text-green-500 text-xl" />
        </a>
      ),
    },
    {
      header: "Mail",
      accessor: "mail",
      render: (row) => (
        <button onClick={(e) => {
          e.stopPropagation();
          setSelectedLead(row);
          setEmailModalOpen(true);
        }}>
          {/* <FaEnvelope className="text-blue-500 text-xl" /> */}
          📧
        </button>
      ),
    },


  ];


  // Actions
  const actions = [
    { label: "🔄 Reload", onClick: handleReload, className: "md:hidden" },
    {
      label: "➕ Add Leads",
      primary: true,
      onClick: () => {
        setSelectedLeads(null);
        setIsAddModalOpen(true);
      },
      className: "md:hidden",
    },

    {
      label: "🗑 Delete Selected",
      onClick: handleDeleteSelected, // ✅ Updated function
      primary: true,


    },
  ];

  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (value) => {
    setSearchQuery(value?.toLowerCase());
  };

  // Corrected filtering logic
  const filteredLeads = leadData?.filter((lead) =>
    lead.name?.toLowerCase().includes(searchQuery)
  );

  const startIndex = (currentPage - 1) * entriesPerPage;
  const LeadpaginatedData = filteredLeads.slice(startIndex, startIndex + entriesPerPage);




  return (
    <>
      <div className="p-4">
        <Table
          title="Leads"
          columns={columns}
          data={LeadpaginatedData}
          actions={actions}

          exportButton={true}
          importButton={true}
          onRowClick={(row) => handleRowClick(row._id)}
          onSearch={handleSearch}
          currentPage={currentPage}
          totalPages={Math.ceil(filteredLeads.length / entriesPerPage)}
          onPageChange={handlePageChange}
          totalEntries={filteredLeads.length}
          entriesPerPage={entriesPerPage}
          entriesOptions={[5, 10, 25, 50, 100, leadData?.length]}
          onEntriesChange={handleLeadEntriesChange}
          loading={loading}
        />
      </div>
      {isAddModalOpen && (
        <AddLeads
          closeAddModal={closeAddModal}
          setIsAddModalOpen={setIsAddModalOpen}
          addLeads={fetchLeads}
          initialLeadData={selectedLeads}
        />
      )}

      {isModalOpen && (
        <ViewLeads
          closeModal={closeModal}
          isModalOpen={isModalOpen}
          openEditModal={openEditModal}
          setLeadData={setLeadData}
          setSelectedLeads={setSelectedLeads}
          leads={selectedLeads}
          leadData={leadData}
        />
      )}


      {emailModalOpen && (
        <EmailModalForLeads
          lead={selectedLead}
          onSubmit={handleEmailSubmit}
          onClose={() => setEmailModalOpen(false)}
          loading={emailLoading}
        />
      )}


    </>
  );
};

export default AllLeads;
